import { getField, updateField } from 'vuex-map-fields';
import NextAvailable from '../../api/next-available';

// initial state
const state = {
    nextAvailableAppointment: null
};

// getters
const getters = {
    getField
};

// actions
const actions = {
    getInformation({ commit, rootState }, { clinicId, dealerId, clientToken, cb }) {
        NextAvailable.getInformation((data) => {
            commit('setStateValue', { key: 'nextAvailableAppointment', value: data.data[0].nextAvailableAppointment });
            if (cb) {
                cb();
            }
        }, { clinicId, dealerId, clientToken });
    },
    
};

// mutations
const mutations = {
    updateField,
    setStateValue(state, payload) {
        state[payload.key] = payload.value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
